export const PREVIEW_MENU = 'Preview Menu';
export const NO_ORDERS_BEING_ACCEPTED_AT_THIS_TIME =
  'No orders are being accepted at this time';

export const SNACKBAR_TITLE = 'Ordering not currently available';
export const SNACKBAR_DEFAULT_MESSAGE =
  'You can browse our available menus, but no orders are being accepted at this time.';
export const SNACKBAR_RE_OPEN_MESSAGE = `${SNACKBAR_DEFAULT_MESSAGE} We will re-open for ordering on`;
